import { render, staticRenderFns } from "./JobsView.vue?vue&type=template&id=b84a4844&scoped=true&"
import script from "./JobsView.vue?vue&type=script&lang=js&"
export * from "./JobsView.vue?vue&type=script&lang=js&"
import style0 from "./JobsView.vue?vue&type=style&index=0&id=b84a4844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84a4844",
  null
  
)

export default component.exports